import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';

const MainLayout = () => {
  
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // initial check

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Consider sidebar collapsed if user collapsed OR screen is mobile
  const isSidebarCollapsed = sidebarCollapsed || isMobile;

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar collapsed={isSidebarCollapsed} />
      <div className={`flex flex-col flex-1 transition-all duration-300 
        ${isSidebarCollapsed ? 'ml-16' : 'ml-64'}`}>
        <Header 
          toggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)} 
          sidebarCollapsed={sidebarCollapsed}
        />
        <main className="flex-1 p-6 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default MainLayout;